"use strict";

import React from "react";

function DesignItemHeader(props) {
  return <div className={"design-list-subheading"}>{props.heading}</div>;
}

export default DesignItemHeader;
